import { types } from "./types.js";

const { auth } = types;

const initialState = {
  isAuthenticated: false,
  currentUser: null,
};

const authReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case auth.SET_AUTH:
      return { ...state, isAuthenticated: payload };
    case auth.SET_CURRENT_USER:
      return { ...state, currentUser: payload };
    default:
      return state;
  }
};

export default authReducer;
